import { ApiHandlerNoApiParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getBrandCategories, GetBrandCategoriesApiParameter } from "@insite/client-framework/Services/BrandService";
import { BrandCategoryCollectionModel, CategoryCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { getCategoriesofAllBrands } from "@tCentro/Services/BrandServiceExtension";

type HandlerType = ApiHandlerNoApiParameter<GetBrandCategoriesApiParameter, BrandCategoryCollectionModel | CategoryCollectionModel>;

export const DispatchBeginBrandId: HandlerType = props => {
    props.dispatch({
        type: "Custom/Brand/BrandFilterId",
        data: props.parameter.brandId, 
    });
};

export const DispatchBeginLoadBrandCategories: HandlerType = props => {
    props.dispatch({
        type: "Custom/Brand/Loading",
        data: true,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    const { brandId } = props.parameter;
    const brandCategoriesCollection = (brandId === "all_brands") ? await getCategoriesofAllBrands({maxDepth: 1,includeStartCategory:false}) : await getBrandCategories(props.parameter);
    props.apiResult = brandCategoriesCollection;
};

export const DispatchCompleteLoadBrand: HandlerType = props => {
    const { brandId } = props.parameter;

    let data: any[] = [];
    if (brandId === "all_brands" && (props?.apiResult as CategoryCollectionModel)?.categories) {
        // Map CategoryModel[] to BrandCategoryModel[] for compatibility
        const categories = (props?.apiResult as CategoryCollectionModel)?.categories;
        if (categories) {
            data = categories.map(cat => ({
                brandId: "",
                categoryId: cat.id,
                categoryName: cat.name,
                categoryShortDescription: cat.shortDescription,
                featuredImagePath: cat.smallImagePath,
                productListPagePath: cat.path,
            }));
        }
    } else if ((props.apiResult as BrandCategoryCollectionModel).brandCategories) {
        data = (props.apiResult as BrandCategoryCollectionModel).brandCategories || [];
    }

    props.dispatch({
        type: "Custom/Brand/BrandCategoriesData",
        data,
    });
};

export const chain = [DispatchBeginBrandId, DispatchBeginLoadBrandCategories, RequestDataFromApi, DispatchCompleteLoadBrand];

const NISCustomLoadBrandData = createHandlerChainRunner(chain, "NISCustomLoadBrandData");
export default NISCustomLoadBrandData;